/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useRef, useEffect } from 'react';
import {
  Animated,
  ActivityIndicator,
  StyleSheet,
  Dimensions,
  View,
} from 'react-native';
import { Portal } from '@gorhom/portal';
import Colors from '@global/colors';
import { isNative, isMobileWeb } from '@global/screens';
import PropTypes from 'prop-types';

const propTypes = {
  show: PropTypes.bool,
  transparent: PropTypes.bool,
};

const defaultProps = {
  show: false,
  transparent: false,
};

const dimension = Dimensions.get('window');

const FullLoader = (props) => {
  const { show = false, transparent = false } = props;

  const fadeIn = useRef(new Animated.Value(0)).current;
  const fadeContentIn = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (show) {
        Animated.parallel([
          Animated.timing(fadeIn, {
            toValue: 1,
            duration: 100,
            useNativeDriver: false,
          }),
          Animated.timing(fadeContentIn, {
            toValue: 1,
            duration: 100,
            useNativeDriver: false,
          }),
        ]).start();
      } else {
        Animated.parallel([
          Animated.timing(fadeIn, {
            toValue: 0,
            duration: 250,
            useNativeDriver: false,
          }),
          Animated.timing(fadeContentIn, {
            toValue: 0,
            duration: 250,
            useNativeDriver: false,
          }),
        ]).start();
      }
    }
    return () => {
      mounted = false;
    };
  }, [show]);

  return (
    <Portal>
      <Animated.View
        style={[
          StyleSheet.absoluteFillObject,
          styles.loaderContainer,
          { opacity: fadeIn },
        ]}>
        <View
          activeOpacity={1}
          style={[
            styles.modalOverlay,
            { backgroundColor: transparent ? 'transparent' : '#00000030' },
          ]}></View>
        <Animated.View
          style={[
            {
              opacity: fadeContentIn,
              backgroundColor: transparent ? 'transparent' : '#00000030',
            },
            styles.overlay,
          ]}>
          <View style={styles.loader}>
            <ActivityIndicator size="large" color={Colors.blue0} />
          </View>
        </Animated.View>
      </Animated.View>
    </Portal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    position: isMobileWeb ? 'fixed' : 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },
  loaderContainer: {
    position: !isNative ? 'fixed' : 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 9,
    elevation: 9,
    paddingTop: 0,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  overlay: {
    width: dimension.width,
    height: dimension.height,
    borderRadius: 5,
    position: !isNative ? 'fixed' : 'relative',
    zIndex: 10,
    elevation: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader: { width: '100%', paddingVertical: 15 },
});

FullLoader.propTypes = propTypes;
FullLoader.defaultProps = defaultProps;

export default FullLoader;
